import get from "lodash.get";
import styled from "styled-components";

export const MenuOptionStyle = styled.div`
  position: relative;
  .wrapper {
    position: absolute;
    right: 0;
    border-radius: 10px;
    background-color: ${({ theme }) => get(theme, "background.main")};
    width: 400px;
    max-height: 400px;
    box-shadow: 0px 0px 2px 0px rgba(160, 160, 160, 0.75);
    overflow: auto;
    z-index: 1000;
    .title {
      border-bottom: 1px solid ${({ theme }) => get(theme, "white.dark")};
      padding: 16px;
      color: ${({ theme }) => get(theme, "text.main")};
    }
    .list {
      margin: 5px 0;
    }
    .item {
      padding: 6px 16px;
      color: ${({ theme }) => get(theme, "text.main")};
      &:hover {
        background-color: ${({ theme }) => get(theme, "background.hoverPrimary")};
      }
    }
  }
`;
